<template>
	<div :class="className" ref="lang" :style="{ height: height, width: width }" />
</template>
<script>
import echarts from "echarts";
export default {
	props: {
		className: {
			type: String,
			default: "chart",
		},
		width: {
			type: String,
			default: "100%",
		},
		height: {
			type: String,
			default: "100%",
		},
		chartData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			chart: null,
		};
	},
	watch: {
		chartData() {
			this.$nextTick(() => {
				this.initChart();
			});
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.initChart();
		});
	},
	beforeDestroy() {
		if (!this.chart) {
			return;
		}
		this.chart.dispose();
		this.chart = null;
	},
	methods: {
		observe() {
			//   const observer = new ResizeObserver(entries => {
			//       this.chart&&this.chart.resize()
			//   })
			//   observer.observe(this.$el)
		},
		getCirlPoint(x0, y0, r, angle) {
			let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
			let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
			return {
				x: x1,
				y: y1,
			};
		},
		initChart() {
			let data = this.chartData.value.toFixed(2);
			let colorList = [
				{
					c1: "#0FC18E",
					c2: "rgba(14, 192, 140, 1)",
					c3: "rgba(84, 255, 233, 1)",
					c4: "rgba(116, 255, 236, 1)",
				},
				{
					c1: "rgba(250, 145, 76, 1)",
					c2: "rgba(250, 135, 66, 1)",
					c3: "rgba(254, 191, 129, 1)",
					c4: "rgba(253, 187, 125, 1)",
				},
				{
					c1: "rgba(41, 178, 246, 1)",
					c2: "rgba(35, 173, 245, 1)",
					c3: "rgba(129, 248, 255, 1)",
					c4: "rgba(122, 242, 255, 1)",
				},
                {
					c1: "rgba(216, 176, 255, 1)",
					c2: "rgba(125, 0, 251, 1)",
					c3: "rgba(220, 186, 255, 1)",
					c4: "rgba(220, 186, 255, 1)",
				},
			];
			let color = colorList[this.chartData.color];
			let option = {
				title: [
					{
						text: this.chartData.name,
						x: "center",
						y: "70",
						textStyle: {
							color: "#00FDFF",
							fontSize: 14,
						},
					},
					{
						text: data + "%",
						x: "center",
						y: "center",
						textStyle: {
							color: "#E3FFFF",
							fontSize: 15,
						},
					},
				],
				// 极坐标系
				polar: {
					radius: ["75%", "100%"],
					center: ["50%", "60%"],
				},
				// 极坐标系：角度轴
				angleAxis: {
					max: 300,
					min: 100,
					show: false,
					type: "value",
					startAngle: 0,
					endAngle: 180,
				},
				// 极坐标系：径向轴
				radiusAxis: {
					type: "category",
					show: true,
					axisLabel: {
						show: false,
					},
					axisLine: {
						show: false,
					},
					axisTick: {
						show: false,
					},
				},
				series: [
					{
						name: "ring5",
						type: "custom",
						coordinateSystem: "none",
						renderItem: (params, api) => {
							let x0 = api.getWidth() / 2;
							let y0 = api.getHeight() / 2 + 13;
							let r = 56;
							let point = this.getCirlPoint(x0, y0, r, 1.8 * (data - 100));
							return {
								type: "circle",
								shape: {
									cx: point.x,
									cy: point.y,
									r: 3,
								},
								style: {
									stroke: color.c4,
									fill: color.c4,
									shadowBlur: 5,
									shadowColor: color.c4,
								},
								silent: true,
							};
						},
						data: [0],
					},
					{
						type: "gauge",
						splitNumber: 5, //刻度数量
						startAngle: 180,
						endAngle: 0,
						radius: "110%", //图表尺寸
						center: ["50%", "60%"],
						axisLine: {
							show: true,
							lineStyle: {
								width: 0,
								shadowBlur: 0,
								color: [
									[data / 100, color.c1],
									[1, "#205C6A "],
								],
							},
						},
						axisTick: {
							show: true,
							lineStyle: {
								color: "auto",
								width: 2,
							},
							length: 2,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						pointer: {
							//仪表盘指针
							show: false,
						},
						detail: {
							show: false,
						},
						data: [80],
					},
					// 第二层：数据以进度条的形式展示
					{
						type: "bar",
						data: [
							{
								value: data,
							},
						],
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
								{
									offset: 0,
									color: color.c2,
								},
								{
									offset: 1,
									color: color.c3,
								},
							]),
						},
						barGap: "-100%",
						coordinateSystem: "polar",
						roundCap: true,
						cursor: "auto",
						z: 2,
					},
					// 第二层：进度条背景
					{
						type: "bar",
						data: [
							{
								value: 100,
							},
						],
						itemStyle: {
							color: "#205C6A",
							borderWidth: 5,
							bordercolor: "",
						},
						coordinateSystem: "polar",
						roundCap: true,
						cursor: "auto",
						emphasis: {
							itemStyle: {
								color: "#205C6A",
							},
						},
						z: 1,
					},
				],
			};

			if (this.chart == null) {
				this.chart = echarts.init(this.$el);
			}
			this.chart.off("click");
			this.chart.on("click", (params) => {
				if (params.componentType == "title") {
					this.$emit("toDetail");
				}
			});
			this.chart.setOption(option);
			this.observe();
		},
	},
};
</script>
